import * as React from 'react'
import { any, async, fromJSX, IOWidget, nothing, Updater } from 'widgets-for-react'
import { PaginationLayout } from './paginationLayout'
import { PaginationState } from './paginationState'

export const paginationWidget =
  (
    currentPage: number,
    perPage: number,
    toPage: (_: number) => string
  ): IOWidget<PaginationState, Updater<PaginationState>> =>
  (paginationState) =>
    any([
      async(paginationState),
      paginationState.kind == 'loaded'
        ? fromJSX(() => (
            <PaginationLayout
              totalItems={paginationState.value}
              currentPage={currentPage}
              toPage={toPage}
              itemsPerPage={perPage}
            />
          ))
        : nothing(),
    ])
